import { hDeepCopy } from '@/utils/helpers';
import ShButton from '@/components/Helpers/ShButton';
import ShPopconfirm from '@/components/Helpers/ShPopconfirm';
import ShUserAvatar from '@/components/Helpers/ShUserAvatar';

// @vue/component
export default {
  name: 'NumbersListItem',

  components: {
    ShButton,
    ShPopconfirm,
    ShUserAvatar,
  },

  props: {
    number: {
      type: Object,
      default: () => ({}),
    },
  },

  computed: {
    isVerified() {
      return this.number.is_verified;
    },
    isAssigned() {
      return this.number.is_verified && !!this.number.assigned_to_agent_id;
    },
    canBeAssigned() {
      return this.number.is_verified && !this.number.assigned_to_agent_id;
    },
    agentsList() {
      return this.$store.getters['agents/list'];
    },
  },

  methods: {
    async handleDeleteNumber() {
      await this.$store.dispatch('numbers/delete', this.number.id);
      await this.$store.dispatch('numbers/getList');
      this.$notify.success({
        title: 'Usuwanie numeru',
        message: `Usunięto numer: ${this.number.number}`,
        customClass: 'callmeweb-notification',
      });
    },
    handleVerifyNumber() {
      this.$EventBus.$emit('NumbersListItem/VERIFY_NUMBER', this.number);
    },
    handleCreateNewAgent() {
      this.$EventBus.$emit('NumbersListItem/CREATE_NEW_AGENT', this.number);
    },
    handleEditAgent() {
      const editableAgent = this.agentsList.find(agent => agent.id === this.number.assigned_to_agent_id);
      this.$EventBus.$emit('NumbersListItem/SHOW_AGENT_DATA', hDeepCopy(editableAgent));
    },
  },
};
